/**
 * @generated SignedSource<<d1c1af22700eb57d70af01fd815a9bb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AnalyticsRouteQuery$variables = {};
export type AnalyticsRouteQuery$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly aiSummaryFeedbackAnalytics: {
      readonly totals: {
        readonly up: number;
        readonly down: number;
        readonly unrated: number;
        readonly total: number;
      };
      readonly byModelVersion: ReadonlyArray<{
        readonly modelVersion: string;
        readonly up: number;
        readonly down: number;
        readonly unrated: number;
        readonly total: number;
      }>;
      readonly byStatus: ReadonlyArray<{
        readonly status: string;
        readonly up: number;
        readonly down: number;
        readonly unrated: number;
        readonly total: number;
      }>;
      readonly overTime: ReadonlyArray<{
        readonly date: string;
        readonly up: number;
        readonly down: number;
        readonly total: number;
      }>;
      readonly recentDownvotes: ReadonlyArray<{
        readonly ticketId: string;
        readonly feedbackText: string | null;
        readonly modelVersion: string;
        readonly generatedAt: string;
      }>;
    } | null;
  } | null;
};
export type AnalyticsRouteQuery = {
  variables: AnalyticsRouteQuery$variables;
  response: AnalyticsRouteQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "up",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "down",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unrated",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelVersion",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "AiSummaryFeedbackAnalytics",
  "kind": "LinkedField",
  "name": "aiSummaryFeedbackAnalytics",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FeedbackCounts",
      "kind": "LinkedField",
      "name": "totals",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelVersionFeedback",
      "kind": "LinkedField",
      "name": "byModelVersion",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusFeedback",
      "kind": "LinkedField",
      "name": "byStatus",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeedbackOverTime",
      "kind": "LinkedField",
      "name": "overTime",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        (v1/*: any*/),
        (v2/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeedbackComment",
      "kind": "LinkedField",
      "name": "recentDownvotes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ticketId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "feedbackText",
          "storageKey": null
        },
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "generatedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalyticsRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AnalyticsRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "25bc6e95e2652308323c03a01bd0e0d2",
    "id": null,
    "metadata": {},
    "name": "AnalyticsRouteQuery",
    "operationKind": "query",
    "text": "query AnalyticsRouteQuery {\n  viewer {\n    actualPersonId\n    aiSummaryFeedbackAnalytics {\n      totals {\n        up\n        down\n        unrated\n        total\n      }\n      byModelVersion {\n        modelVersion\n        up\n        down\n        unrated\n        total\n      }\n      byStatus {\n        status\n        up\n        down\n        unrated\n        total\n      }\n      overTime {\n        date\n        up\n        down\n        total\n      }\n      recentDownvotes {\n        ticketId\n        feedbackText\n        modelVersion\n        generatedAt\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d205315ea092d79965dbd8e7ae661367";

export default node;
